export default __webpack_public_path__ + "static/media/safemars-video-2.40f21e38.mp4";